module.exports = __webpack_public_path__ + "img/new-business-hero.73c53d12.svg";